import {createBrowserHistory, History} from "history";

const history: History = createBrowserHistory();
export default history;

// @ts-ignore
window.cy_history = history;
